import Papa from "papaparse";
import { saveAs } from "file-saver";
import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { FunnelIcon } from "@heroicons/react/24/outline";
import DashboardHeader from "../components/DashboardHeader";
import DashboardSideBar from "../components/DashboardSideBar";

export default function AuditLogPage() {
  const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL ?? "http://localhost:8000/api";
  const { authToken } = useAuth();

  const [search, setSearch] = useState("");

  const [logs, setLogs] = useState([]);


  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({});
  //   try {
  //     const params = new URLSearchParams(filters).toString();

  //     const res = await fetch(`${url}?${params}`, {
  //       headers: {
  //         Authorization: `Bearer ${authToken}`,
  //         Accept: "application/json",
  //       },
  //     });

  //     const data = await res.json();
  //     setLogs(data.logs.data);
  //     setPagination(data.logs);
  //   } catch (error) {
  //     console.error("Failed to fetch audit logs", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchLogs = async (url = `${API_BASE_URL}/audit-logs`) => {
    try {
      const params = new URLSearchParams({ search }).toString();

      const res = await fetch(`${url}?${params}`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
          Accept: "application/json",
        },
      });

      const data = await res.json();
      setLogs(data.logs.data);
      setPagination(data.logs);
    } catch (error) {
      console.error("Failed to fetch audit logs", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCSVExport = () => {
    const data = logs.map((log) => ({
      Actor: log.actor_name,
      Role: log.actor_role,
      Action: log.action,
      Description: log.description,
      IP_Address: log.ip_address,
      Date: new Date(log.created_at).toLocaleString(),
    }));

    if (data.length === 0) {
      alert("No audit logs to export");
      return;
    }

    const csv = Papa.unparse(data);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `audit_logs_${Date.now()}.csv`);
  };

  useEffect(() => {
    if (authToken) fetchLogs();
  }, [authToken]);

  return (
    <div className="min-h-screen bg-gray-50">
      <DashboardSideBar />

      <div className="md:ml-64">
        <DashboardHeader PageTitle="Audit Logs" />

        <div className="p-6 max-w-7xl mx-auto">
          {/* Filters */}
          <div className="flex flex-col md:flex-row gap-3 mb-4">
            <input
              type="text"
              placeholder="Search actor, role, action, description or IP..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="border p-2 rounded w-full md:w-2/3"
            />

            <button
              onClick={() => {
                setLoading(true);
                fetchLogs();
              }}
              className="bg-green-900 text-white px-4 py-2 rounded"
            >
              Search
              <FunnelIcon className="inline-block w-4 h-4 ml-2" />
            </button>

            <button
              onClick={handleCSVExport}
              className="bg-blue-700 text-white px-4 py-2 rounded"
            >
              Export CSV
            </button>
          </div>

          {/* Table */}
          {loading ? (
            <p>Loading audit logs...</p>
          ) : (
            <div className="overflow-x-auto bg-white rounded shadow">
              <table className="w-full text-sm">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="p-3">Actor</th>
                    <th>Role</th>
                    <th>Action</th>
                    <th>Description</th>
                    <th>IP</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {logs.map((log) => (
                    <tr key={log.id} className="border-t">
                      <td className="p-3 font-medium">{log.actor_name}</td>

                      <td>{log.actor_role}</td>
                      <td className="font-semibold">{log.action}</td>
                      <td>{log.description}</td>
                      <td>{log.ip_address}</td>
                      <td>{new Date(log.created_at).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Pagination */}
          <div className="flex justify-between mt-4">
            <button
              disabled={!pagination.prev_page_url}
              onClick={() => fetchLogs(pagination.prev_page_url)}
            >
              Previous
            </button>

            <button
              disabled={!pagination.next_page_url}
              onClick={() => fetchLogs(pagination.next_page_url)}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
